
<template>
  <div class="page-header-bar" v-html="sysHeaderDesc"></div>
</template>
<script>
import { queryOrgs } from '@uc/api/otp'
import { getPrivilegeGroup } from '@uc/api/user'
import { getWebConfig } from "@frame/api/common/index";
export default {
  data () {
    return {
      sysHeaderDesc: "",
      privilegeGroup: ''
    };
  },
  created () {
    let user = this.$getCurrInfo();
    getPrivilegeGroup({ 'userId': user["rootUserId"] }).then(r => {
      if (r.data.success && r.data.privilegeGroup !== '' && typeof (r.data.privilegeGroup) !== 'undefined') {
        queryOrgs({ 'status': '0', 'page_no': 1, 'page_size': 100, 'org_code': r.data.privilegeGroup }).then(r => {
          let datas = r.data.rows
          if (datas.lenght > 0) {
            this.privilegeGroup = datas[0]['orgName'];
          }
          this.getDbWebConfig();
        }).catch(e => {
          console.error(e)
        })
      } else {
        this.getDbWebConfig();
      }
    }).catch(e => {
      console.log(e)
    })
  },
  methods: {
    getDbWebConfig () {
      // 获取页头配置
      getWebConfig({ code: "r_sys_header" })
        .then((r) => {
          if (r.data.success) {
            this.sysHeaderDesc = r.data.value.replace('privilegeGroup', this.privilegeGroup)
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style scoped lang="scss">
.page-header-bar {
  min-width: 200px;
  // line-height: 50px;
  height: 48px;
  color: #ffffff;
  background: #fff;
}
</style>
